import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import { connect } from 'react-redux';

import { updateProgram } from '../../shared/redux/entities/actions'

import { getAgencyPrograms } from '../../shared/redux/selectors'
import AccountProgramList from "./components/AccountProgramList";

function mapStateToProps(state,props){
  return {
    programs:getAgencyPrograms(state, props.accountId)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ updateProgram },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountProgramList));



// WEBPACK FOOTER //
// ./src/routes/AccountProgramList/index.js